export default "__VITE_ASSET__7cee3593__"